import { withRouter } from 'react-router';
import SuggestionsField from '../../SuggestionsField';
import withAutocomplete from '../../Containers/withAutocomplete';
import { getCurrentRegion } from '../../Helpers';

const createRegionSlug = (path) => {
  const region = getCurrentRegion();
  if (!region) return path;

  return `/api/${region.Slug}/hjv/suggest`;
};

const createQueryString = (props) => {
  let qs = `&st=${props.st}&g=${props.g}&caretype=${props.caretype}`;
  if (props.nearby === true) {
    qs += `&lng=${props.lng}&lat=${props.lat}&nearby=true`;
  }

  return qs;
};

const UnitSuggestion = withRouter(
  withAutocomplete(
    SuggestionsField,
    createRegionSlug('/api/hjv/suggest'),
    (hits) => (hits && hits.Units ? [...hits.Units] : []),
    (selectedObject) => {
      if (selectedObject.FriendlyUrl) {
        window.location.href = selectedObject.FriendlyUrl;
        return '';
      } else {
        return selectedObject.DisplayName;
      }
    },
    (item, value) => value,
    -1,
    createQueryString,
    3
  )
);

export default UnitSuggestion;
